import { Table } from "@ttc3k/trekker";
import { EnumRoomType, Maybe, Room, useTagByIdsQuery } from "gql/generated";
import { i18nLanguage } from "i18n";
import _ from "lodash";
import pluralize from "pluralize";
import { getMultilingualString } from "shared/utils";

type RoomRowProps = {
  room: Room | Maybe<Room>;
  index: number;
  language: i18nLanguage;
  translatedBedroomString: string;
};

export const RoomRow = ({
  room,
  index,
  language,
  translatedBedroomString,
}: RoomRowProps) => {
  const { data, error, loading } = useTagByIdsQuery({
    variables: { ids: room?.amenities },
  });

  if (error && !loading) {
    throw new Error("Error fetching amenities on room");
  }

  if (!room || room?.type === EnumRoomType.Bath) {
    return null;
  }

  const amenities = data?.tagByIds;

  const amenitiesString = amenities
    ?.map(amenity => {
      const amenityCounts = _.countBy(room.amenities);
      return pluralize(
        getMultilingualString(amenity.name, language),
        amenityCounts[amenity._id],
        true,
      );
    })
    .join(" • ");

  return (
    <Table.Row fontSize={"xs!"} lineHeight={"xs!"}>
      <Table.Header fontWeight={"medium!"}>
        {translatedBedroomString} {index + 1}
      </Table.Header>
      <Table.Cell>{amenitiesString}</Table.Cell>
    </Table.Row>
  );
};
